import React from 'react';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration, currentUser, scrambleWords, userHasViewAccess } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);
    return isTargetCategory;
  };
  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  const cleanPropsForCustomFields = propsForCustomFields.filter(i => !i.key.endsWith("Filter"));

  if (publicData.listingType == "search" && !cleanPropsForCustomFields.find(i => i.key == "Location_preference")) {
    cleanPropsForCustomFields.push({
      "schemaType": "text",
      "key": "Location_preference",
      "heading": "Location preference",
      "text": "N/A",
    });
  } else if (publicData.listingType == "sell" && !cleanPropsForCustomFields.find(i => i.key == "approximate_asset_location")) {
    cleanPropsForCustomFields.push({
      "schemaType": "text",
      "key": "approximate_asset_location",
      "heading": "Location",
      "text": "N/A",
    });
  };

  return <>
    {cleanPropsForCustomFields.map(customFieldProps => {
      const { schemaType, ...fieldProps } = customFieldProps;
      return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
        <SectionMultiEnumMaybe
          {...fieldProps}
          scrambleWords={scrambleWords}
          showAsCommaSeparated
        />
      ) : null;
    })}

    <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} scrambleWords={scrambleWords} />

    {cleanPropsForCustomFields.map(customFieldProps => {
      const { schemaType, ...fieldProps } = customFieldProps;
      return schemaType === SCHEMA_TYPE_TEXT ? (
        <SectionTextMaybe {...fieldProps} currentUser={currentUser} publicData={publicData} scrambleWords={scrambleWords} userHasViewAccess={userHasViewAccess} />
      ) : null;
    })}
  </>
};

export default CustomListingFields;
